import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Components
import DisputesHeaderDark from "../DisputesHeaderDark";

import BlogPostLayout04 from "../../Pages/Blogs/LayoutPage/BlogPostLayout04";
import DisputesFooter from "../DisputesFooter";

function NewsDetail(props) {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [allNews, setAllNews] = useState(null);

  useEffect(() => {
    getNews();
  }, [id]);

  const getNews = () => {
    try {
      axios
      .get(`${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}news/`)
      .then((res) => res.data)
      .then((data) => {
        setNewsItem(data.find((item) => item.newsid === parseInt(id, 10)));
        setAllNews(data.filter((item) => item.newsid !== parseInt(id, 10)).sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6));
      })
    } catch (error) {

      console.log(error)
    }


  };

  if (!newsItem) {
    return ;
  }

  return (
    <>
      <DisputesHeaderDark />

      <BlogPostLayout04 data={newsItem} />


      {/* Footer Start */}
      <DisputesFooter
        theme="dark"
        className="text-[#828282] bg-darkgray consulting-footer"
      />
      {/* Footer End */}
    </>
  );
}

export default NewsDetail;
